import { ChangeDetectionStrategy, Component, effect, inject, input } from '@angular/core'
import { isDefined } from '@pai/commons'

import { AnalyticsService } from 'app/core/analytics/analytics.service'
import { PageDto } from 'app/core/cms/generated/api-types'
import { Hero, Section } from 'app/core/cms/type-unions'
import { explicitComputed } from 'app/utils/signal-utils'

import { InsertDynamicHeroDirective } from '../../dynamic-components/insert-dynamic-hero.directive'
import { InsertDynamicSectionDirective } from '../../dynamic-components/insert-dynamic-section.directive'

@Component({
  selector: 'pai-site-page',
  imports: [InsertDynamicHeroDirective, InsertDynamicSectionDirective],
  templateUrl: './page-site.component.html',
  styleUrl: './page-site.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class PageSiteComponent {
  readonly site = input.required<PageDto>()

  protected heroes = explicitComputed(this.site, ({ hero }: PageDto): readonly Hero[] => (hero ?? []).filter(isDefined))
  protected sections = explicitComputed(
    this.site,
    ({ sections }: PageDto): readonly Section[] => sections ?? [].filter(isDefined),
  )

  constructor() {
    const analytics = inject(AnalyticsService)
    effect(() => analytics.trackPageView(`/${this.site().slug}`))
  }
}
